import { render, staticRenderFns } from "./All_Footer.vue?vue&type=template&id=bb5bc71a&scoped=true&"
import script from "./All_Footer.vue?vue&type=script&lang=js&"
export * from "./All_Footer.vue?vue&type=script&lang=js&"
import style0 from "./All_Footer.vue?vue&type=style&index=0&id=bb5bc71a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5bc71a",
  null
  
)

export default component.exports